<div class="modal-header">
    <span class="modal-title">Complete Time Logs</span>
    <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form class="form-inline">
        <div class="form-group">
            <div class="input-group">
                <input class="form-control" placeholder="yyyy-mm-dd" name="dp" [(ngModel)]="currentDate" ngbDatepicker
                    #d="ngbDatepicker" (ngModelChange)="filterChange()" readonly>
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"></button>
                </div>
            </div>
        </div>

        <div class="btn-group btn-group-toggle" ngbRadioGroup name="radioBasic" [(ngModel)]="type">
            <label ngbButtonLabel class="btn-primary">
                <input ngbButton type="radio" [value]="1"> With Logs
            </label>
            <label ngbButtonLabel class="btn-primary">
                <input ngbButton type="radio" [value]="0"> Without Logs
            </label>
        </div>
    </form>

    <div *ngIf="type === 1" class="margin-top">
        <div class="grid timeins justifycenter">
            <div class="row rowborder rowheader">
                <div class="col centerMedium flexcol">
                    Employee No
                </div>
                <div class="col centerMedium flexcol">
                    Fullname
                </div>
                <div class="col centerMedium flexcol">
                    Time In / Out
                </div>
            </div>
            <div class="row rowborder" *ngIf="logs?.daytran.length === 0">
                <div class="col centerMedium flexcol">
                    No Results Found
                </div>
            </div>
            <div class="row rowborder timeinrow" *ngFor="let log of logs?.daytran">
                <div class="col centerMedium flexcol">
                    {{log?.empno}}
                </div>
                <div class="col centerMedium flexcol">
                    {{log?.fullname}}
                </div>
                <div class="col centerMedium flexcol">
                    {{log?.timereg}} {{log.ampm}}
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="type === 0" class="margin-top">
        <div class="grid timeins justifycenter">
            <div class="row rowborder rowheader">
                <div class="col centerMedium flexcol">
                    Employee No
                </div>
                <div class="col centerMedium flexcol">
                    Fullname
                </div>
            </div>
            <div class="row rowborder" *ngIf="logs?.nologs.length === 0">
                <div class="col centerMedium flexcol">
                    No Results Found
                </div>
            </div>
            <div class="row rowborder timeinrow" *ngFor="let log of logs?.nologs">
                <div class="col centerMedium flexcol">
                    {{log?.empno}}
                </div>
                <div class="col centerMedium flexcol">
                    {{log?.fullname}}
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="close()">Close</button>
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>